module.exports = __webpack_public_path__ + "assets/instagram.7e61d05d.svg";